import type { SelectOption } from '@presentation/components';
import type { HTMLAttributes, MouseEventHandler } from 'react';

export type InputRadioVariant = 'original' | 'blue';
export interface InputRadioProps<TValue> extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  options: SelectOption<TValue>[];
  onSelect?: (selectedOption: SelectOption<TValue>) => void;
  multiple?: boolean;
  value?: TValue | TValue[];
  disabled?: boolean;
  grow?: boolean;
  showAdd?: boolean;
  separated?: boolean;
  separatedOnDesktop?: boolean;
  onAddClick?: MouseEventHandler;
  hasError?: boolean;
  autoHeight?: boolean;
  autoWidth?: boolean;
  hideSelectedIcon?: boolean;
  name?: string;
  langSelector?: boolean;
  variant?: InputRadioVariant;
  preventDefault?: boolean;
}
